import { useTranslation } from 'next-i18next';

import {
  PRODUCT_TAG_COA_2_YEAR_DISPATCH,
  PRODUCT_TAG_COA_3_YEAR_DISPATCH,
  PRODUCT_TAG_COA_4_YEAR_DISPATCH,
  PRODUCT_TAG_COA_5_YEAR_DISPATCH,
  PRODUCT_TAG_COA_AVANT_ARTE,
  PRODUCT_TAG_COA_BESPOKE_EMBOSSED,
} from '../constants/product';

export const useCertificateOfAuthenticity = (
  noCoa: boolean,
  productTags: string[],
) => {
  const { t } = useTranslation('product');

  if (noCoa) {
    return null;
  }

  if (productTags.includes(PRODUCT_TAG_COA_2_YEAR_DISPATCH)) {
    return t('coaMessage', { count: 2 });
  }

  if (productTags.includes(PRODUCT_TAG_COA_3_YEAR_DISPATCH)) {
    return t('coaMessage', { count: 3 });
  }

  if (productTags.includes(PRODUCT_TAG_COA_4_YEAR_DISPATCH)) {
    return t('coaMessage', { count: 4 });
  }

  if (productTags.includes(PRODUCT_TAG_COA_5_YEAR_DISPATCH)) {
    return t('coaMessage', { count: 5 });
  }

  if (productTags.includes(PRODUCT_TAG_COA_AVANT_ARTE)) {
    return t('coaIncludedByAA');
  }

  if (productTags.includes(PRODUCT_TAG_COA_BESPOKE_EMBOSSED)) {
    return t('coaIncludedBespokeEmbossed');
  }

  return t('coaIncluded');
};
